import { memo } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

const TicketNumbers = ({ passengers, doShowFlightTickets, doShowServiceFeeTickets }) => {
  let propName = '';
  if (doShowFlightTickets) propName = 'flightTicketNumbers';
  else if (doShowServiceFeeTickets) propName = 'serviceFeeTicketNumbers';
  else return <></>;
  const passWithFlightNums = _.filter(
    passengers,
    (t) =>
      t.travelerPreferences &&
      t.travelerPreferences[propName] &&
      Object.keys(t.travelerPreferences.flightTicketNumbers).length,
  );

  if (!passWithFlightNums || !passWithFlightNums.length) return <></>;
  return (
    <div className="text-sm">
      <div className="font-bold">Ticket #:</div>
      {passWithFlightNums.map((p, index) =>
        p.travelerPreferences[propName] && Object.keys(p.travelerPreferences[propName]).length ? (
          <div key={`${index.toString()}`}>
            {p.firstName} {p.lastName}:{' '}
            {Object.entries(p.travelerPreferences[propName])
              .map(([key, value]) => (value && value.status ? `${key} (${value.status})` : key))
              .join(', ')}
          </div>
        ) : (
          <></>
        ),
      )}
    </div>
  );
};

TicketNumbers.propTypes = {
  passengers: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  doShowFlightTickets: PropTypes.bool,
  doShowServiceFeeTickets: PropTypes.bool,
};

TicketNumbers.defaultProps = {
  doShowFlightTickets: false,
  doShowServiceFeeTickets: false,
};

export default memo(TicketNumbers);
